import { OutfitSlotName } from 'types/outfit';
import { IQuality } from 'types/qualities';

export default function sortInPossessionsTabOrder(items: IQuality[]) {
  const canonicalOrder: OutfitSlotName[] = [
    // Standard
    'Hat',
    'Clothing',
    'Gloves',
    'Weapon',
    'Boots',
    'Companion',
    'Destiny',
    // Expanded
    'Affiliation',
    'Transportation',
    'HomeComfort',
    'Ship',
    'Spouse', // ?????
    'Club',
  ];
  return [...items]
    .sort((a, b) => canonicalOrder.indexOf(a.category as OutfitSlotName) - canonicalOrder.indexOf(b.category as OutfitSlotName));
}